import Cropper from './cropper';

export default Cropper;
